import React from 'react';
import './Careers.css';
import CareersHero from './careers/CareersHero';
import CareersDomains from './careers/CareersDomains';
import CareersEarly from './careers/CareersEarly';
import CareersPeople from './careers/CareersPeople';
import CareersValues from './careers/CareersValues';
import CareersProcess from './careers/CareersProcess';
import CareersInsights from './careers/CareersInsights';
import CareersNewsletter from './careers/CareersNewsletter';

const Careers: React.FC = () => {
  return (
    <div className="careers-page">
      <CareersHero />
      <CareersDomains />
      <CareersEarly />
      <CareersPeople />
      <CareersValues />
      <CareersProcess />
      <CareersInsights />
      <CareersNewsletter />
    </div>
  );
};

export default Careers;